module.exports = __webpack_public_path__ + "assets/chevron-right.877776f0.svg";